import React from 'react';
import Window from './src/containers/window';
import { renderToStaticMarkup } from 'react-dom/server';
import { LocalizeProvider } from 'react-localize-redux';

import { languages, onMissingTranslation, translations } from './src/locale';
import SEOTranslations from './src/components/seo/ja.locale';

/**
 * Create localize provider for each page
 * Required as only this initialize prop works for SSR
 * Note: Linking to redux causes there to be a delay in initialization. This in turn means that any other language files added by children component get overwritten.
 */
export default ({ element, props }) => {
  return (
    <LocalizeProvider
      initialize={{
        languages,
        translation: {
          ...translations,
          ...SEOTranslations,
          ...props.pageContext.translations
        },
        options: { renderToStaticMarkup, onMissingTranslation }
      }}
    >
      <Window {...props}>{element}</Window>
    </LocalizeProvider>
  );
};
